/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/api-v2-client";
import type { UsersAuthzGetManagedPermissionsPermissionsOfUserQueryResponse, UsersAuthzGetManagedPermissionsPermissionsOfUserPathParams, UsersAuthzGetManagedPermissionsPermissionsOfUser401, UsersAuthzGetManagedPermissionsPermissionsOfUser403 } from "../models/UsersAuthzGetManagedPermissionsPermissionsOfUser";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { usersAuthzGetManagedPermissionsPermissionsOfUser } from "../axios/usersAuthzGetManagedPermissionsPermissionsOfUser";
import { queryOptions, useQuery } from "@tanstack/react-query";

export const usersAuthzGetManagedPermissionsPermissionsOfUserQueryKey = (userId: UsersAuthzGetManagedPermissionsPermissionsOfUserPathParams["userId"]) => ["api-v2", { url: '/users-authz/v1/users/:userId/permissions', params: {userId:userId} }] as const

export type UsersAuthzGetManagedPermissionsPermissionsOfUserQueryKey = ReturnType<typeof usersAuthzGetManagedPermissionsPermissionsOfUserQueryKey>

export function usersAuthzGetManagedPermissionsPermissionsOfUserQueryOptions(userId: UsersAuthzGetManagedPermissionsPermissionsOfUserPathParams["userId"], config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = usersAuthzGetManagedPermissionsPermissionsOfUserQueryKey(userId)
        return queryOptions<UsersAuthzGetManagedPermissionsPermissionsOfUserQueryResponse, ResponseErrorConfig<UsersAuthzGetManagedPermissionsPermissionsOfUser401 | UsersAuthzGetManagedPermissionsPermissionsOfUser403>, UsersAuthzGetManagedPermissionsPermissionsOfUserQueryResponse, typeof queryKey>({
         enabled: !!(userId),
         queryKey,
         queryFn: async ({ signal }) => {
            return usersAuthzGetManagedPermissionsPermissionsOfUser(userId, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @description Requires CLIENT_ADMIN role or client API key
 * @summary Get all permissions for a specific user
 * {@link /users-authz/v1/users/:userId/permissions}
 */
export function useUsersAuthzGetManagedPermissionsPermissionsOfUser<TData = UsersAuthzGetManagedPermissionsPermissionsOfUserQueryResponse, TQueryData = UsersAuthzGetManagedPermissionsPermissionsOfUserQueryResponse, TQueryKey extends QueryKey = UsersAuthzGetManagedPermissionsPermissionsOfUserQueryKey>(userId: UsersAuthzGetManagedPermissionsPermissionsOfUserPathParams["userId"], options: 
{
  query?: Partial<QueryObserverOptions<UsersAuthzGetManagedPermissionsPermissionsOfUserQueryResponse, ResponseErrorConfig<UsersAuthzGetManagedPermissionsPermissionsOfUser401 | UsersAuthzGetManagedPermissionsPermissionsOfUser403>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...queryOptions } = queryConfig
         const queryKey = queryOptions?.queryKey ?? usersAuthzGetManagedPermissionsPermissionsOfUserQueryKey(userId)
         

         const query = useQuery({
          ...usersAuthzGetManagedPermissionsPermissionsOfUserQueryOptions(userId, config),
          queryKey,
          ...queryOptions
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<UsersAuthzGetManagedPermissionsPermissionsOfUser401 | UsersAuthzGetManagedPermissionsPermissionsOfUser403>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}